import { Injectable } from '@angular/core';
import { CoreService } from '../core.service';

@Injectable({
  providedIn: 'root'
})
export class ImageryLayersService {
  private imageryProviders: any[] = [];

  constructor(private core: CoreService) {}

  addImageryLayer(provider: any): any {
    const viewer = this.core.getViewer();
    const layers = viewer.imageryLayers;
    const addedProvider = layers.addImageryProvider(provider);
    
    this.imageryProviders.push(addedProvider);
    return addedProvider;
  }

  removeImageryLayer(provider?: any): void {
    // TODO: Implement removal logic
  }

  getImageryLayers(): any[] {
    return this.imageryProviders;
  }
}